module.exports = __webpack_public_path__ + "media/images/countrysquared/az-c4e7e8a06954fd81b802a1f5466f48a1.svg";